/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import Background from 'components/common/Background';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CountUp from 'react-countup';
import bg1 from 'assets/img/icons/spot-illustrations/corner-1.png';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
import bg3 from 'assets/img/icons/spot-illustrations/corner-3.png';

const CustomTooltip = ({ content }) =>
  content ? (
    <div
      style={{
        position: 'absolute',
        // top: position.top,
        // left: position.left,
        background: 'white',
        color: 'black',
        padding: '8px',
        borderRadius: '4px',
        zIndex: 1000, // Adjust the z-index as needed
        fontSize: '14px',
        maxWidth: '90%',
        borderColor: '#d3d3d3',
        border: '1px solid #d3d3d3',
        boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
        lineHeight: '1.2'
      }}
      className="custom-tooltip"
    >
      <span style={{ fontSize: '12px' }}>{content}</span>
    </div>
  ) : (
    <></>
  );

const StatisticsCard = ({ stat, index, ...rest }) => {
  const { sign, value, info, title, suffix, desc } = stat;
  let valueClassName = 'text-warning';
  let badgeBg = 'warning';
  let className = '';
  let cardBackground = bg1;
  const decimal = true;
  if (sign === 'positive') {
    cardBackground = bg3;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'neutral') {
    cardBackground = bg2;
    badgeBg = 'info';
    valueClassName = 'text-info';
  } else if (sign === 'negative') {
    cardBackground = bg1;
    badgeBg = 'warning';
    valueClassName = 'text-warning';
  } else if (sign === 'Excellent') {
    cardBackground = bg3;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'Good') {
    cardBackground = bg3;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'Average') {
    cardBackground = bg2;
    badgeBg = 'info';
    valueClassName = 'text-info';
  } else if (sign === 'Below Average') {
    cardBackground = bg1;
    badgeBg = 'warning';
    valueClassName = 'text-warning';
  } else if (sign === 'Poor') {
    cardBackground = bg1;
    badgeBg = 'danger';
    valueClassName = 'text-danger';
  } else if (sign === 'Very Poor') {
    cardBackground = bg1;
    badgeBg = 'danger';
    valueClassName = 'text-danger';
  }

  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleTitleHover = () => {
    setTooltipVisible(true);
  };

  const handleTitleLeave = () => {
    setTooltipVisible(false);
  };

  // console.log(stat)
  return (
    <Card className={classNames(className)} {...rest}>
      <Background image={cardBackground} className="bg-card" />
      <Card.Body className="position-relative">
        <h5
          onMouseEnter={handleTitleHover}
          onMouseLeave={handleTitleLeave}
          style={{ cursor: desc ? 'pointer' : '', width: 'fit-content' }}
          className="d-flex justify-content-center align-items-center"
        >
          {title}
          {sign && (
            <SoftBadge bg={badgeBg} pill className="ms-2 card-badge-text">
              {sign}
            </SoftBadge>
          )}
        </h5>
        {isTooltipVisible && <CustomTooltip content={desc} />}
        <div
          className={classNames(
            valueClassName,
            'display-4 fs-4 mb-2 font-sans-serif card-fw-2'
          )}
        >
          <CountUp
            start={0}
            end={value}
            duration={2.75}
            suffix={suffix}
            prefix={''}
            separator=","
          />
        </div>
        <h6 className="mb-0 mt-2 score-card-text">{info}</h6>
      </Card.Body>
    </Card>
  );
};

StatisticsCard.propTypes = {
  stat: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    sign: PropTypes.string,
    info: PropTypes.string.isRequired
  })
};

export default StatisticsCard;
